import { jsx as _jsx, Fragment as _Fragment } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { EVENT_TYPES, subscribe, unsubscribe } from '@stepstone/events-js';
import { getSubscriptionEvents, getUpdateFunctionsCustomEvent, getUpdateFunctionsPubSub, } from './eventsSubscriptions.js';
import { DialogWrapper } from './DialogWrapper/index.js';
import { closeModalThunk, isGDPRModalActiveSelector } from './modalSlice.js';
import { useAppDispatch, useAppSelector } from '../../hooks.js';
import { removeDynamicGlobalTrackingLibraryScript } from '../../../tracking/tools.js';
import { trackingResetPasswordStateSelector } from '../../../views/ResetPassword/resetPasswordSlice.js';
import { modalNavigationMiddleware } from './modalNavigationMiddleware.js';
import { pageNavigationMiddleware } from '../Page/pageNavigationMiddleware.js';
import { useConsentLevelSubscriber } from '../../../helpers/useConsentLevel.js';
import { useGDPRModalActive } from '../../../helpers/useConsentLevel.js';
import { modalFormConfigs } from './modalFormConfigs.js';
import { showRegistrationSuccessfulModalSelector } from '../../../views/Registration/registrationSlice.js';
import CVUploadModal from '../../features/registrationSuccess/RegistrationSuccessModal/index.js';
import { encodedGTLibraryUrlSelector, logoBrandNameSelector, } from '../../core/siteConfig/siteConfigSlice.js';
import { activeViewSelector, isWrapperActiveSelector, WRAPPER_TYPES, twoStepTrackingComponentStateSelector, activeWrapperSelector, } from '../../core/wrapperContext/wrapperContextSlice.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
export const Modal = () => {
    const dispatch = useAppDispatch();
    const isWrapperActive = useAppSelector(isWrapperActiveSelector(WRAPPER_TYPES.MODAL));
    const activeView = useAppSelector(activeViewSelector);
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const resetPasswordComponentState = useAppSelector(trackingResetPasswordStateSelector);
    const encodedGTLibraryUrl = useAppSelector(encodedGTLibraryUrlSelector);
    const logoBrandName = useAppSelector(logoBrandNameSelector);
    const twoStepModalComponentState = useAppSelector(twoStepTrackingComponentStateSelector);
    const isGDPRModalActive = useAppSelector(isGDPRModalActiveSelector);
    const showRegistrationSuccessfulModal = useAppSelector(showRegistrationSuccessfulModalSelector);
    const { trackBtnClick } = useTrack('generic');
    useConsentLevelSubscriber();
    useGDPRModalActive();
    // todo move this logic somewhere else
    const hideModal = () => {
        if (activeView === 'resetPassword') {
            trackBtnClick({
                uniqueName: 'modalClose',
                genericComponentState: resetPasswordComponentState,
            });
        }
        else if (activeView === 'twoStepResetPassword') {
            trackBtnClick({
                uniqueName: 'modalClose',
                genericComponentState: 'resetPasswordEnterEmailForm',
            });
        }
        else if (activeView === 'twoStepResetPasswordSuccess') {
            trackBtnClick({
                uniqueName: 'modalClose',
                genericComponentState: 'resetPasswordAttempted',
            });
        }
        else if (activeWrapper === WRAPPER_TYPES.STEP_MODAL &&
            twoStepModalComponentState) {
            trackBtnClick({
                uniqueName: 'modalClose',
                genericComponentState: twoStepModalComponentState,
            });
        }
        else if (activeView === 'linkedInImportProfile') {
            document.dispatchEvent(new Event(EVENT_TYPES.CANDIDATE_PROFILE_EVENTS.LINKEDIN_IMPORT_PROFILE_MODAL_CLOSED_ON_JOB_AD));
            trackBtnClick({
                uniqueName: 'modalClose',
            });
        }
        else {
            trackBtnClick({
                uniqueName: 'modalClose',
            });
        }
        modalNavigationMiddleware.remove();
        pageNavigationMiddleware.resume();
        removeDynamicGlobalTrackingLibraryScript();
        dispatch(closeModalThunk());
    };
    const updateFunctions = getUpdateFunctionsCustomEvent(encodedGTLibraryUrl, logoBrandName, dispatch);
    const updateFunctionsPubSub = getUpdateFunctionsPubSub(encodedGTLibraryUrl, logoBrandName, dispatch);
    const eventsToSubscribe = getSubscriptionEvents({
        ...updateFunctions,
        hideModal,
    });
    const eventsToSubscribePubSub = getSubscriptionEvents({
        ...updateFunctionsPubSub,
        hideModal,
    });
    useEffect(() => {
        eventsToSubscribe.map((event) => {
            subscribe(event.eventName, event.updateFunction);
        });
        if ('PubSub' in window) {
            eventsToSubscribePubSub.map((event) => {
                window.PubSub.subscribe(event.eventName, event.updateFunction);
            });
        }
        return () => {
            eventsToSubscribe.map((event) => {
                unsubscribe(event.eventName, event.updateFunction);
            });
            if ('PubSub' in window) {
                eventsToSubscribePubSub.map((event) => {
                    window.PubSub.unsubscribe(event.eventName);
                });
            }
        };
    });
    const modalForms = modalFormConfigs();
    if (!isWrapperActive) {
        return null;
    }
    if (showRegistrationSuccessfulModal) {
        return _jsx(CVUploadModal, {});
    }
    return (_jsx(_Fragment, { children: modalForms.map(({ component, type, fullscreenModal }) => {
            const FormComponent = component;
            return (_jsx(DialogWrapper, { hideModal: hideModal, isModalVisible: activeView === type && !isGDPRModalActive, modalType: type, fullscreenModal: fullscreenModal, children: _jsx(FormComponent, {}) }, type));
        }) }));
};
//# sourceMappingURL=Modal.js.map